import { NoOptionsMessageProps } from "@deliverr/react-select-v1";
import { FC } from "react";
import { SearchNoOptions } from "../../AsyncSelectComponents";

export const ProductSearchNoOptions: FC<NoOptionsMessageProps> = SearchNoOptions;
